

// import counterReducer from '../features/counter/counterSlice';
import { RESTEntityAdapter } from 'persistent-react-entities/client/RESTEntityAdapter';
import { OfflineEntityAdapter } from './OfflineEntityAdapter';


//export const MiniGroup = new RESTEntityAdapter("MiniGroup"); // an instance of a creature
//export const Creature = new RESTEntityAdapter("Creature"); // a template for minis
// export const Sheet = new RESTEntityAdapter("Sheet"); // a sheet containing minis

export const MiniGroup = new OfflineEntityAdapter("MiniGroup", { localStore: true }); // an instance of a creature
export const Creature = new OfflineEntityAdapter("Creature", { localStore: true }); // a template for minis
export const Sheet = new OfflineEntityAdapter("Sheet", { localStore: true }); // a sheet containing minis
export const Settings = new OfflineEntityAdapter("Settings", { localStore: true});

/*

```mermaid

classDiagram

  class Sheet {
      name : String
      paperSize : json //  w, h   in inches
  }

  class Creature { 
      size : int
      src : url
      heightRatio : float // height = size * heightRatio  
  }

  class MiniGroup {
      count: int
      x : float / pos in percentage
      y : floit 
      count : int

  }


  Sheet o-- "*" Creature
  Sheet *-- "*" MiniGroup
  MiniGroup *-- "*" Mini
  MiniGroup -- Creature 


```

*/